import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import bg from '../../images/offer-bg.webp'
import infra from "../../images/ware.jpg"
import { useMediaQuery } from 'react-responsive';


const Offer = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
    return (
        <div className='offer-section section-padding position-relative'
        //  style={{ backgroundImage: `url(${infra})` }}
         >
            <Container>
                <Row>
                <Col lg={6}>
                    <img className='infrsimage' src={infra}></img>
                    </Col>
                    <Col lg={6}>
                        <div className='position-relative offercontent'>
                            <h2 className={`text-capitalize ${isMobile ? 'mb-2': 'mb-4'}`}>Warehousing Solutions</h2>
                            <h6 className='text-capitalize'>Our warehousing services are designed to optimize your supply chain. With state-of-the-art facilities and advanced logistics management, we ensure your storage and distribution needs are met seamlessly.</h6>
                          
                        </div>
                    </Col>
                   
                </Row>
            </Container>
        </div>
    )
}

export default Offer
